import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=4c410af0&"
import script from "./Performance.vue?vue&type=script&lang=ts&"
export * from "./Performance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports